<template>
  <b-overlay :show="formShow" rounded="sm" no-fade class="mt-1">
    <b-card>
      <b-row class="mb-1">
        <b-col
          cols="12"
          md="7"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            variant="outline-primary"
            class="btn-icon"
            @click="$router.go(-1)"
          >
            <i class="fa-solid fa-arrow-left"></i>
            <span class="ml-25">Back</span>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col" v-if="objectiveId">Objective Edit</th>
              <th scope="col" v-else>Objective Add</th>
            </tr>
          </thead>
        </table>
      </b-row>

      <validation-observer ref="objectiveRules">
        <b-form>
          <b-row>
            <b-col cols="6" md="3" sm="12">
              <b-form-group label="Year" label-for="year">
                <validation-provider
                  name="year"
                  #default="{ errors }"
                  rules="required"
                >
                  <v-select
                    v-model="objectiveValue.year"
                    :options="years"
                    :clearable="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="6" md="12" sm="12">
              <b-form-group label="Objective Title" label-for="title">
                <validation-provider
                  name="title"
                  #default="{ errors }"
                  rules="required"
                >
                  <textarea
                    v-model="objectiveValue.title"
                    class="form-control"
                    id="title"
                    name="title"
                    rows="3"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="6" md="12" sm="12">
              <b-form-group label="Pillar Title" label-for="pillar">
                <validation-provider
                  name="pillar title"
                  #default="{ errors }"
                  rules="required"
                >
                  <v-select
                    v-model="objectiveValue.pillar_title_id"
                    label="title"
                    :reduce="(val) => val.id"
                    :options="pillarTitles"
                    :clearable="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <hr />

          <b-row>
            <b-col cols="12">
              <b-button
                v-if="objectiveId == null"
                type="submit"
                @click.prevent="formSubmitted"
                variant="primary"
                class="float-right"
              >
                Save
              </b-button>
              <b-button
                v-else
                type="submit"
                @click.prevent="formSubmitted"
                variant="primary"
                class="float-right"
              >
                Save Changes
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>
<script>
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../settingsStoreModule";
import vSelect from "vue-select";
import router from "@/router";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";

export default {
  components: {
    vSelect,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },

  setup() {
    const OBJECT_CODE_APP_STORE_MODULE_NAME = "settings";
    // Register module
    if (!store.hasModule(OBJECT_CODE_APP_STORE_MODULE_NAME))
      store.registerModule(
        OBJECT_CODE_APP_STORE_MODULE_NAME,
        settingsStoreModule
      );

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(OBJECT_CODE_APP_STORE_MODULE_NAME))
        store.unregisterModule(OBJECT_CODE_APP_STORE_MODULE_NAME);
    });
  },

  data() {
    return {
      objectiveValue: {
        title: "",
        pillar_title_id: "",
        year: null,
      },
      pillarTitles: [],
      years: Array.from({ length: 10 }, (_, i) => 2020 + i),
      formShow: false,
      objectiveId: null,
    };
  },

  watch: {},

  mounted() {
    this.getObjectiveById();
    this.getPillarTitles();
  },

  methods: {
    getPillarTitles() {
      store
        .dispatch("settings/getAllPillarTitles")
        .then((res) => {
          this.pillarTitles = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "An error occurred",
              text: "Please try again later or contact support.",
              icon: "AlertCircleIcon",
              variant: "danger",
            },
          });
        });
    },

    getObjectiveById() {
      if (router.currentRoute.params.id) {
        this.formShow = true;
        this.objectiveId = parseInt(router.currentRoute.params.id);

        store
          .dispatch("settings/getObjectiveById", {
            id: router.currentRoute.params.id,
          })
          .then((res) => {
            this.objectiveValue = res.data;
            this.formShow = false;
          })
          .catch((error) => {
            console.log(error);
            this.formShow = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "An error occurred",
                text: "Please try again later or contact support.",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          });
      }
    },

    formSubmitted() {
      this.formShow = true;

      this.$refs.objectiveRules.validate().then((success) => {
        if (success) {
          if (this.objectiveId == null) {
            store
              .dispatch("settings/saveObjective", this.objectiveValue)
              .then((response) => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Successful",
                    text: "✔️ Objective Added Successfuly",
                    icon: "ThumbsUpIcon",
                    variant: "success",
                  },
                });

                router.push({ name: "settings-objectives" });
              })
              .catch((error) => {
                this.formShow = false;
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "An error occurred",
                    text: "Please try again later or contact support.",
                    icon: "AlertCircleIcon",
                    variant: "danger",
                  },
                });
              });
          } else {
            store
              .dispatch("settings/updateObjective", this.objectiveValue)
              .then((response) => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Successful",
                    text: "✔️ Objective Update Successful",
                    icon: "ThumbsUpIcon",
                    variant: "success",
                  },
                });

                router.push({ name: "settings-objectives" });
              })
              .catch((error) => {
                this.formShow = false;
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "An error occurred",
                    text: "Please try again later or contact support.",
                    icon: "AlertCircleIcon",
                    variant: "danger",
                  },
                });
              });
          }
        } else {
          this.formShow = false;
        }
      });
    },
  },
};
</script>

<style>
.animate__animated {
  animation-fill-mode: none;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
